// Russian (ru-RU)
export default {
	title: "Способы оплаты",
	tips: "Уважаемый пользователь, пожалуйста, укажите свой адрес ERC20/TRC20. Пожалуйста, не вводите данные своего банковского счета и пароль",
	form: {
		TransactionPassword: "Пароль транзакции",
		Address: "Адрес кошелька"
	},
	label: ["Название банка", "Код отделения", "Название отделения", "Тип депозита", "Номер счета", "Владелец счета"],
	tabs: ["Банковская карта", "Сеть"],
	delete: "Удалить",
	default: "По умолчанию",
	create: "Создать",
	type: "Тип вывода",
	verifying: "проверка",
	VerifyWalletAddress: "Подтвердить адрес кошелька",
	defaultAccount: "Счет по умолчанию для вывода",
	deleteMsg: "Вы уверены, что хотите удалить?"
};
